import type { PromoCandidate } from '@supply-mover-2-0/shared';
import { PromoTile } from './PromoTile';

/**
 * Full-width hero banner. Renders the first selected promo at hero
 * size. Selection helper enforces limit=1 by default for this widget
 * type.
 */
export function PromoBannerWidget({
	promos,
	density,
	onLikelyStaleUrl,
}: {
	promos: Array<PromoCandidate>;
	density?: 'standard' | 'compact';
	onLikelyStaleUrl?: () => void;
}): JSX.Element | null {
	const promo = promos[0];
	if (promo == null) return null;
	return (
		<div className="w-full h-full">
			<PromoTile
				promo={promo as never}
				size="hero"
				density={density}
				onLikelyStaleUrl={onLikelyStaleUrl}
			/>
		</div>
	);
}
